export enum ProductType {
    TOP_UP = 'TOP_UP',
    DIGITAL_VOUCHER = 'DIGITAL_VOUCHER',
}
